import React from "react";
import dns from "images/dns.png";

export const Dns = () => (
  <div style={{ alignSelf: "center" }}>
    <img src={dns} alt={"dns"} />;
  </div>
);

export default Dns;
